import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase設定 (home-plate-manager)
const firebaseConfig = {
  apiKey: "AIzaSyBXecwFDfkgyUyOHHtQ-HzR3GBKzvUwbHo",
  authDomain: "home-plate-manager.firebaseapp.com",
  projectId: "home-plate-manager",
  storageBucket: "home-plate-manager.firebasestorage.app",
  messagingSenderId: "901980731650",
  appId: "1:901980731650:web:be990e235a98eb548e2a1b"
};

// Firebaseアプリを初期化
const app = initializeApp(firebaseConfig);

// 認証
export const auth = getAuth(app);

// Firestore（長時間の接続を避けるための設定）
export const db = getFirestore(app);

// Storage
export const storage = getStorage(app);

// AbortError を無視（開発時のみ）
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args: any[]) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('AbortError')
    ) {
      return; // AbortErrorを無視
    }
    originalError.apply(console, args);
  };

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.name === 'AbortError') {
      event.preventDefault();
    }
  });
}

export default app;
